import PropTypes from 'prop-types';
import './pageHeading.scss';

const PageHeading = ({ children, headingType = 'h2' }) => {
  const Component = headingType || 'h2';
  return <Component className="iw-page-heading">{children}</Component>;
};

PageHeading.propTypes = {
  children: PropTypes.node.isRequired,
  headingType: PropTypes.string,
};

export default PageHeading;
